import { isProduction } from '@libs/environment';

export const config = {
  HOST: isProduction() ? 'https://gofinans.com' : 'https://blog.fintech.dev2.scrij.com',
  SENTRY_DSN: 'https://53af032e3f92e8369f0823957664db02@sentry.agilie.com/36',
  ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
};
